<template>
  <base-layout>
    <div style="margin-bottom:-20px;height:100%;">
      <div class="row" style="margin-top:0px;">
        <div class="col-md-3 header" style="margin: 0;">
          <p v-if="$route.query.Supervisor != undefined" class="dcaa-section-heading" style="color: #143361;">DCAA
            Reports</p>
          <p v-else-if="TraineeEmployeeId" class="heading" style="color: #143361;">{{EmployeeName}} Timesheet Activity
          </p>
          <p v-else class="heading" style="color: #143361;">{{this.loggedInUserObj.name }} Timesheet Activity</p>
        </div>
        <div class="col-md-9">
          <span class="cross-mark">
            <span class="nextImg" @click="redirect()" style="font-size: 20px;float:right">&#10006;</span>
          </span>
        </div>
      </div>
      <ob-layout :type="10" style="">
        <template slot="left-section">
          <div class="actfilter-body">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <h3 class="title">Filters</h3>
                </div>
                <div class="col-md-6" style="margin-top:12px; text-align: right;">
                  <a :disabled="isLoading && isApplyButtonClicked"  @click="apply" style="color:#0da8e4;">Apply</a>
                  <!-- </div>
                <div class="col-md-2" style="margin-top:12px"> -->
                  <a :disabled="isLoading && isResetButtonClicked"  @click="reset" style="color:#d60000;">Reset</a>
                </div>
              </div>
              <div class="row log_content">
                <h5 class="actsubtitle ">Activity Performed By</h5>
                <div class="form-group" style=" padding-left:20px;padding-right:15px">
                  <ob-select2 :multiple="true" v-if="showSupervisor" :options="activityofList"
                    v-model="performedActivity"> </ob-select2>
                </div>
              </div>
              <div class="row log_content">
                <h5 class="actsubtitle ">Select Project</h5>
                <div class="form-group" style=" padding-left:15px;padding-right:15px">
                  <ob-select2 :multiple="true" v-if="projectStatus" v-model.trim=" selectionofProjects"
                    :options="listProjects"></ob-select2>
                </div>
              </div>
              <div class="row log_content">
                <h5 class="actsubtitle ">Select End Client</h5>
                <div class="form-group" style=" padding-left:15px;padding-right:15px">
                  <ob-select2 v-if="projectStatus" :options="listOfCients" v-model="selectionofclient"></ob-select2>
                </div>
              </div>
              <div class="row log_content">
                <h5 class="actsubtitle ">Action Type</h5>
                <div class="form-group" style=" padding-left:15px;padding-right:15px">
                  <ob-select2 :options="actionPurpose" v-model="actiontype"></ob-select2>
                </div>
              </div>
              <div class="row log_content">
                <h5 class="actsubtitle ">Activity Performed On</h5>
                <div class="form-group" style=" padding-left:15px;padding-right:15px">
                  <ob-select2 :options="activityPurpose" v-model="activityperformedon"></ob-select2>
                  <div class=" row content_btn">
                    <div v-if="activityperformedon == 'Custom_Date'">
                      <div class="col-md-6">
                        <label>From</label>
                        <ob-date-time-picker :inputvalue="dateFrom" v-model="dateFrom" ref="dateFrom" id="dateFrom"
                          :options="DateRangeFromOptions" @updated="(v) => this.dateFrom = v"></ob-date-time-picker>
                      </div>
                      <div class="col-md-6">
                        <label>To</label>
                        <ob-date-time-picker :inputvalue="dateTo" v-model="dateTo" ref="dateTo" id="dateTo"
                          :options="DateRangeToOptions" @updated="(v) => this.dateTo = v"></ob-date-time-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- Section -->
        <template slot="right-section">
          <div class="act-body">
            <div class="row" style="margin:10px;">
              <div class="row col-md-12 pR0" style="display: block; padding : 10px 0px 10px 40px;">
              <div class="col-md-6 pL0">
                <ob-input class="searchText SearchInput" icon="fa-search" id="search" placeholder="Search Keywords"
                  @focus="search()" v-model="searchText" @click="searchData" @keyup.native.enter="searchData">
                </ob-input>
              </div>
              <div class="col-md-4" style="text-align: right; padding-top: 7px;">
                <span v-if="activityNames != null || activityNames != undefined" class="count_text_css">
                <span v-if="activityNames.length == 0">0</span>
                <span v-else>1</span> - {{activityNames.length}} of {{totalCount}}
              </span>
              </div>
              <div class="col-md-2" style="text-align: end;">
                <ob-button type="secondary" @click="downloadreport"> <i class="fa fa-download"
                    aria-hidden="true"></i>Download</ob-button>
              </div>
            </div>
              <!-- <ob-spinner type="section" v-if="isLoading" loading-text="Loading..."></ob-spinner> -->
              <div class="row col-md-12 pR0" style="display: block; padding : 10px 0px 10px 40px;">
                <div class="MT-Content-table" v-if="activityNames.length == 0 && !isLoading">
                  <div class="MT-Content">
                    <h3 style="font-size: 18px; margin-top:140px">No Results found</h3>
                  </div>
                </div>
                <div v-else class="col-md-12 pR0" style="display: block;">
                  <table ref="table" class="row col-md-12 table table-striped">
                    <thead class="col-md-12" style="padding: 0px; position: absolute; z-index: 1;">
                      <tr class="col-md-12" style="display: flex !important; padding: 0px !important;">
                        <th scope="col" class="col-md-2">Date & Time</th>
                        <th scope="col" class="col-md-2">Name/UserID</th>
                        <th scope="col" class="col-md-3">Action Type</th>
                        <th scope="col" class="col-md-5">Activity</th>
                      </tr>
                    </thead>
                    <tbody id="tab" @scroll="onScroll" class="table_body col-md-12" style="padding: 0px;">
                      <tr v-for="(item,index) in searchQuery" :key="item.id" class="col-md-12 table_body_tr">
                        <td class="col-md-2">
                          <span :id="'tdspan'+(index*7)" class="filterSpan">
                            <!-- {{item.timeanddate}} -->
                            <template>
                              <text-highlight :queries="queries">
                                {{item.timeanddate}}
                              </text-highlight>
                            </template>
                          </span>
                        </td>
                        <td class="col-md-2">
                          <p class="filterSpan"><span :id="'tdspan'+(index*7 + 1)">
                              <!-- {{item.name}} {{item.lastname}} {{item.currentrole}} -->
                              <template>
                                <text-highlight :queries="queries">
                                  {{item.name}} {{item.lastname}} {{item.currentrole}}
                                </text-highlight>
                              </template>
                            </span></p>
                          <p style="font-size:10px" class="filterSpan"> <span :id="'tdspan'+(index*7 + 2)">
                              <!-- {{item.email}} -->
                              <template>
                                <text-highlight :queries="queries">{{item.email}}</text-highlight>
                              </template>
                            </span>
                          </p>
                        </td>

                        <td class="filterSpan col-md-3">
                          <span :id="'tdspan'+(index*7 + 3)">
                                <template>
                                  <text-highlight :queries="queries">
                                    {{item.status}}
                                  </text-highlight>
                                </template>
                          </span>
                        </td>

                        <td class="col-md-5">
                          <p v-show="item.activity">
                            <!-- {{item.activity}} -->
                            <template>
                              <text-highlight :queries="queries">
                                {{item.activity}}
                              </text-highlight>
                            </template>
                          </p>
                          <p class="filterSpan" v-if="item.fromdate != null && item.fromdate !=''">Timesheet Range :<b>
                              <span :id="'tdspan'+(index*7 + 4)">
                                <!-- {{item.fromdate}} to {{item.todate}} -->
                                <template>
                                  <text-highlight :queries="queries">
                                    {{item.fromdate}} to {{item.todate}}
                                  </text-highlight>
                                </template>
                              </span></b></p>
                          <p class="filterSpan" v-if="item.totalhours != null && item.totalhours != ''">Total Hours:<b>
                              <span :id="'tdspan'+(index*7 + 5)">
                                <!-- {{item.totalhours}} -->
                                <template>
                                  <text-highlight :queries="queries">
                                    {{item.totalhours}}
                                  </text-highlight>
                                </template>
                              </span></b></p>
                          <p class="filterSpan" v-if="item.totalhours != null && item.totalhours != ''">Project:
                            <b>
                              <span :id="'tdspan'+(index*7 + 6)">
                                <!-- {{item.project}} -->
                                <template>
                                  <text-highlight :queries="queries">
                                    {{item.project}}
                                  </text-highlight>
                                </template>
                              </span>
                            </b>
                          </p>
                          <p v-if="item.comments != null && item.comments != ''">Comments:
                            <b>
                              <span :id="'tdspan'+(index*7 + 7)">
                                <!-- {{item.comments}} -->
                                <template>
                                  <text-highlight :queries="queries">
                                    {{item.comments}}
                                  </text-highlight>
                                </template>
                              </span>
                            </b>
                          </p>
                        </td>

                      </tr>
                      <!-- <ob-spinner id="ob_table_spinner_id" class="row lazy_spinner_css" v-if="true" type="section"
                        loading-text="Loading...">
                      </ob-spinner> -->
                      <div id="ob_table_spinner_id" class="row lazy_spinner_css" v-if="isLoading" type="section">
                        <div style="width: 100%; text-align: center; position: relative;">
                          <svg class="spinner_svg_css" viewBox="25 25 50 50">
                            <circle class="spinner_circle_css" cx="50" cy="50" r="20" fill="none" stroke-width="2"
                              stroke-miterlimit="10">
                            </circle>
                          </svg>
                          <p class="spinner_text_css">Loading...</p>
                        </div>
                      </div>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>
        </template>
      </ob-layout>
      <employee-popup :NewLogTrail.sync="openlogpopover" :actiontype="actiontype" :performedActivity="performedActivity"
        :activityperformedon="activityperformedon" :selectionofProjects="selectionofProjects" :data="activityNames">
      </employee-popup>
    </div>
  </base-layout>
</template>

<script>
import c from 'Vue/Core/constants.js'
import EmployeePopup from "../Timesheets/EmployeePopup.vue"
import { required, minLength, maxLength, requiredIf, email, alpha, minValue, maxValue } from 'vuelidate/lib/validators';
export default {
  name: "DCAAReports",
  data() {
    return {
      isResetButtonClicked:false,
      isApplyButtonClicked:false,
      queries: [''],
      isReachedBottom: false,
      listOfCients: {
        placeholder: {
          id: "-1",
          text: "Select EndClient"
        },
        data: []
      },
      selectionofclient: '',
      TraineeEmployeeId: '',
      EmployeeName: '',

      consultantId: '',
      openlogpopover: false,
      searchData: '',
      PageSize: 20,
      listCount: 0,
      totalCount: 0,
      PageIndex: 0,
      searchText: '',
      performedActivity: '',
      selectionofProjects: '',
      projectDetails: [],
      getHrlist: [],
      actiontype: '',
      activityperformedon: '',
      showSupervisor: false,
      showSignatoryauthorityList: false,
      projectListGet: [],
      candidateInformation: {
        consultantId: '',
      },
      employeeSelected: '',
      employeeOptionList: [],
      EmpList: [],
      ReportingEmpList: [],
      projectStatus: false,
      activityNames: [],
      isLoading: false,
      activityList: [],
      actionPurpose: {
        data: [{ id: 'All', text: 'All' },
        { id: 'Submitted', text: 'Submitted' },
        { id: 'Approved', text: 'Approved' },
        { id: 'Rejected', text: 'Rejected' },
        { id: 'RequestedForEdit', text: 'Requested For Edit' },
        { id: 'EditRequestApproved', text: 'Edit Request Approved' },
        { id: 'Re_Submitted', text: 'Re-Submitted' }],
        placeholder: {
          id: '-1',
          text: 'Select '
        }
      },
      activityPurpose: {
        data: [{ id: 'All_Activities ', text: 'All Times' },
        { id: 'Today', text: 'Today' },
        { id: 'Yesterday', text: 'Yesterday' },
        { id: 'This_Week', text: 'This Week' },
        { id: 'Past_2_Week', text: 'Past 2 Weeks' },
        { id: 'This_Month', text: 'This Month' },
        { id: 'Last_Month', text: 'Last Month' },
        { id: 'Custom_Date', text: 'Custom Date' },
        ],
        placeholder: {
          id: '-1',
          text: 'Select '
        }
      },
      dateFrom: '',
      dateTo: '',
      DateRangeToOptions: {
        format: "MM/DD/YYYY",
        dayViewHeaderFormat: "MM/DD/YYYY",
        widgetPositioning: {
          horizontal: 'right',
          vertical: 'top'
        }
      },
      DateRangeFromOptions: {
        format: "MM/DD/YYYY",
        dayViewHeaderFormat: "MM/DD/YYYY",
        widgetPositioning: {
          horizontal: 'left',
          vertical: 'top'
        }
      },
    }

  },
  validations() {
    return {
      "employeeSelected": {
        requiredIf: requiredIf((a) => {
          if (this.$route.query.from == 'employer-timesheets') {
            return true
          } else {
            return false
          }
        })
      },
    }
  },
  watch: {
    // selectionofProjects(){
    //     this.getSearchFilter()
    //   },
    //   performedActivity(){
    //      this.getSearchFilter()
    //       },
    //   actiontype(){
    //    this.getSearchFilter()
    //   },
    //   activityperformedon(){
    //      this.getSearchFilter()
    //   }

  },
  computed: {
    ReportingEmployeeIdList() {
      return this.ReportingEmpList.map(m => m.EmployeeId)
    },
    ReportingConIdList() {
      return this.ReportingEmpList.map(m => m.ConsultantId)
    },
    ReportingEmailList() {
      return this.ReportingEmpList.map(m => m.Email)
    },
    activityofList() {
      var options = {}
      options.placeholder = {
        id: '-1',
        text: 'Select'
      }
      var data = this.activityList.filter((b) => b.id != '')
      options.data = data
      var template = function (data) {
        let result = '';
        //  result +='<div class="row "><div class="col-md-12"><div class="col-md-2" style="padding-right:20px">'+'<input type="checkbox"/>'+'</div><div class="col-md-2"  style="padding-left:10px;padding-right:10px"> <i class="fa fa-user-circle" style="font-size:24px;margint-top:40px"></i></div><div class="col-md-8" style="padding-left:3px"><h4 style="font-weight: 600;">'+data.text +'</h4><p style="padding-top:20px;margin-top:-30px">'+data.Email+'</p></div></div></div>'
        result += '<div class="row "><div class="col-md-12"><div class="col-md-2"  style="padding-left:10px;padding-right:10px"> <i class="fa fa-user-circle" style="font-size:24px;margint-top:40px"></i></div><div class="col-md-8" style="padding-left:3px"><h4 style="font-weight: 600;">' + data.text + '</h4><p style="padding-top:20px;margin-top:-30px">' + data.Email + '</p></div></div></div>'
        return $(result);
      }
      options.templateResult = template
      return options;
    },
    listProjects() {
      var options = {}
      options.placeholder = {
        id: '-1', // the value of the option
        text: 'Select'
      }
      var data = this.projectListGet.filter(l => l.ProjectId != '')
      options.data = data
      var template = function (data) {
        let result = '';
        result += '<div style="width:200px"><div class="row "><div class="col-md-12"><div style="font-weight: 600;font-size: 15px;width: 180px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">' + data.text + '</div></div></div>'
        result += '<div class="row" style="padding-top:10px"><div class="col-md-12">' + '<span style="padding-left:5px"> ' + data.Status + '</span>' + '</div></div></div>'
        result += '<div class="row" style="padding-top:10px"><div class="col-md-6">' + '<img src="' + c.CDNIMAGESBASEURL + '/ess/ESSApp/static/Images/dcaa/briefcase.svg" style="width:15px;margin-bottom:4px;float:left;margin-right: 8px;"/>' + '<div style=""> ' + data.EndClientOrganizationName + '</div>' + '</div></div></div>'
        result += '<div class="row" style="padding-top:10px"><div class="col-md-12">' + '<img src="' + c.CDNIMAGESBASEURL + '/ess/ESSApp/static/Images/dcaa/pin.svg" style="width: 15px;margin-bottom:4px"/>' + '<span style="padding-left:5px"> ' + data.Location + '</span>' + '</div></div></div>'



        return $(result);
      }
      options.templateResult = template
      return options;
    },
    searchQuery() {
      if (this.searchText) {
        this.search()
        return this.activityNames.filter((item) => {
          return this.searchText.toString().split(' ')
        })
      } else {
        return this.activityNames;
      }
    },
    //         searchQuery(){
    //   if(this.searchText){
    //   return this.names.filter((item)=>{
    //     return this.searchText.toLowerCase().split(' ').every(v => item.name.toLowerCase().includes(v))
    //   })
    //   }else{
    //     return this.names;
    //   }
    // },

    EmployeeId() {
      return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
    },
  },
  components: {
    "employee-popup": EmployeePopup
  },
  created() {
    this.getEmployeeList();

    if (this.$route.query.id != undefined) {
      this.TraineeEmployeeId = this.$route.query.id;
    }

    this.EmployeeName = JSON.parse(localStorage.getItem("EmployeeName"))
    setTimeout(() => {
      this.getSearchFilter()
    }, 1000);
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if((!this.isApplyButtonClicked && !this.isResetButtonClicked) && (scrollTop + clientHeight >= (scrollHeight - 10))) {
        this.PageIndex = ++this.PageIndex;
        this.isReachedBottom = true;
        this.getSearchFilter();
      }
    },
    getEmployeeList() {
      let _this = this;
      ajax.get(
        `/Supervisor/GetReportingEmployeeList?empId=${this.EmployeeId}`,
        {},
        res => {
          if (res.data.resultList.length > 0) {
            _this.ReportingEmpList = res.data.resultList;

          }
          else {

          }
          _this.getProjectList();
          _this.getSignatoryauthorityList();
        }
      );
    },
    search() {
      const search = document.getElementById('search');
      search.addEventListener('input', (event) => {
        const searchText = event.target.value;
        this.queries = [searchText]

      })

    },
    downloadreport() {
      this.openlogpopover = true
    },
    getSignatoryauthorityList() {
      this.showSignatoryauthorityList = false
      var empId = this.TraineeEmployeeId;
      // this.showSupervisor =false
      var _this = this;
      // this.activityofList.data = [];
      ajax.get(`TimeSheets/GetOrganizationHrsList?employeeId=${empId}&empOrgId=${loggedInUserObj.orgId}`, {}, (res) => {
        var hrlist = __.map(res.data.SignatoryModelList, (t) => {
          return { 'id': t.Id, 'text': t.BasicModel.Name, 'Email': t.Email }
        })

        var supervisorList = __.map(_this.ReportingEmpList, (t) => {

          return { 'id': t.EmployeeId, 'text': t.Name, 'Email': t.Email }

        })

        var totalList = hrlist.concat(supervisorList)

       // if (_this.$route.query.Supervisor != undefined)
        {
          totalList = totalList.concat({ 'id': _this.loggedInUserObj.consultantId, 'text': _this.loggedInUserObj.name, 'Email': _this.loggedInUserObj.email })
        }
        _this.activityofList.data = totalList

        _this.showSupervisor = true

        // ajax.get(`/OnBoard/GetSupervisorList?consultantId=${this.candidateInformation.consultantId}`, {}, (res) => {
        // var supervisorList = __.map(res.data.SupervsiorList, (t) => {
        //       if(_this.ReportingEmployeeIdList.includes(t.Id))
        //       {
        //        return { 'id': t.Id, 'text': t.Name,'Email':t.Email }
        //       }
        //     })
        //  var totalList=hrlist.concat(supervisorList)
        //  this.activityofList.data=totalList
        //  this.showSupervisor = true
        //   })
      })
    },
    redirect() {
      this.$router.push({ 'name': 'my-timesheets' })
    },
    reset() {
      this.isResetButtonClicked = true,
      this.activityperformedon = '';
      this.actiontype = '';
      this.selectionofProjects = '';
      this.performedActivity = '';
      this.selectionofclient = '';
      this.dateFrom = '';
      this.dateTo = '';
      this.getSearchFilter();
    },
    apply() {
      this.isApplyButtonClicked = true;
      this.getSearchFilter()
    },
    empOrgId() {
      return this.loggedInUserObj.OrgId
    },
    OrganisationId() {
      return this.loggedInUserObj.orgId ? this.loggedInUserObj.orgId : '';
    },
    getSearchFilter() {
      // this.activityNames = []
      this.isLoading = true;
      if (this.isReachedBottom != true) {
        this.activityNames = [];
        this.PageIndex = 0;
      }

      var projectList = []
      var actionsperfomedbyUsers = []
      var actionList = []
      var empId = [];
      if (this.$route.query.Supervisor != undefined) {
        if (this.ReportingEmpList.length > 0) {
          empId = this.ReportingEmpList.map(v => v.EmployeeId);
        }
      }
      else if (this.TraineeEmployeeId != undefined && this.TraineeEmployeeId != null && this.TraineeEmployeeId != '') {
        empId = [this.TraineeEmployeeId]
      }
      else {
        empId = [this.EmployeeId]
      }

      if (this.selectionofProjects != null && this.selectionofProjects != "") {
        var list = this.projectDetails.filter(v => this.selectionofProjects.includes(v.JobId)).map(m => m.Id);
        if (list.length > 0) {
          projectList = list;
        }
      }
      if (this.selectionofclient != null && this.selectionofclient != '') {
        var list = this.projectDetails.filter(v => v.EndClientOrganizationName == this.selectionofclient).map(m => m.Id);
        if (list.length > 0) {
          projectList.push.apply(projectList, list)
        }
      }
      if (this.performedActivity != null && this.performedActivity != "") {
        actionsperfomedbyUsers.push(this.performedActivity)
      }
      if (this.actiontype != null && this.actiontype != '') {
        actionList.push(this.actiontype)
      }
      // this.isLoading = true
      var obj = {
        'ActionsList': actionList,
        'ActionsPerformedByUsersList': this.performedActivity != '' ? this.performedActivity : [],
        'ActionsPerformedDateRange': this.activityperfomedon,
        'TimesheetIdList': [],
        'ProjectIdList': projectList,
        'EmployeeId': empId,
        'FromDate': this.dateFrom,
        'ToDate': this.dateTo
      }
      ajax.put(`/TimeSheets/Activity?orgId=${this.OrganisationId()}&pageNo=${this.PageIndex}&pageSize=${this.PageSize}`, obj, (res) => {
        if (res.data.State == true) {
          this.$loading({ 'loadingText': 'Loading...' })
          if (res.data.data.length != 0) {
            var responsedata = res.data.data;
            this.totalCount = res.data.count;

            if(this.isApplyButtonClicked || this.isResetButtonClicked)
            {
              this.activityNames = [];
            }
            responsedata.forEach((e) => {
              if(e.actions == 3)
              {
                e.activityLogMessage = e.metaInformation.Reason;
                e.metaInformation.TimesheetActionType = "Delete"
              }
              this.activityNames.push(
                {
                  "timeanddate": moment(e.activityLogDateTime.Date).format("MM/DD/YYYY h:mm A"),
                  "timezone": e.activityLogDateTime.TimeZone,
                  "email": e.actionDoneBy.Email,
                  "name": e.actionDoneBy.FirstName,
                  "lastname": e.actionDoneBy.LastName,
                  "currentrole": e.actionDoneBy.CurrentRole,
                  "fromdate": e.metaInformation.FromDate,
                  "todate": e.metaInformation.ToDate,
                  "comments": e.activityLogMessage,
                  "status": e.metaInformation.TimesheetActionType != null && e.metaInformation.TimesheetActionType != '' ? e.metaInformation.TimesheetActionType.replace(/([a-z])([A-Z])/g, '$1 $2') : '',
                  "totalhours": e.metaInformation.TotalHours,
                  "project": e.metaInformation.Project != null &&  e.metaInformation.Project != '' ?  e.metaInformation.Project : 'N/A'
                })
            });
            setTimeout(() => {
              this.isResetButtonClicked = false;
              this.isApplyButtonClicked = false;
            }, 1000);
            this.isReachedBottom = false;


          }

        };
        // for (var i = 0; i <= 15; i++) {
        //   this.activityNames.push(
        //     {
        //       "timeanddate": "04/10/2022",
        //       "timezone": "",
        //       "email": "test@gmail.com",
        //       "name": "prithvi",
        //       "lastname": "mailnator",
        //       "currentrole": "Developer",
        //       "fromdate": "09/04/2021",
        //       "todate": "02/15/2022",
        //       // "comments": e.activityLogMessage,
        //       "comments": " This is test fo activity for search text... ",
        //       "status": "inprogress",
        //       "totalhours": "259",
        //       "project": "Test project"
        //     }
        //   );
        // };
        this.listCount = this.activityNames.length;
        this.$loading({}).close();
        this.isLoading = false;
      })
    },

    getUnique(arr, comp) {
      const unique = arr
        .map(e => e[comp])
        // store the keys of the unique objects
        .map((e, i, final) => final.indexOf(e) === i && i)
        // eliminate the dead keys & store unique objects
        .filter(e => arr[e]).map(e => arr[e]);
      return unique;
    },
    //To get project list
    getProjectList() {
      this.projectStatus = false;
      var _this = this;
      var empId = '';
      if (this.$route.query.Supervisor != undefined) {
        empId = ''
      }
      else if (this.TraineeEmployeeId != null && this.TraineeEmployeeId != '') {
        empId = this.TraineeEmployeeId
      }
      else if (this.EmployeeId != null && this.EmployeeId != '') {
        empId = this.EmployeeId;
      }
      ajax.get(`/TimeSheets/ProjectDetails?orgId=${this.OrganisationId()}&&empId=${empId}`, {}, (res) => {
        if (res.data.State == true) {

          _this.projectDetails = res.data.ProjectDetails;
          if (_this.$route.query.Supervisor != undefined) {
            _this.projectDetails = res.data.ProjectDetails.filter(v => _this.ReportingConIdList.includes(v.ConsultantId));
          }
          let projectsList = this.getUnique(_this.projectDetails, "JobId")
          _this.listProjects.data = __.map(projectsList, (t) => {
            return {
              'id': t.JobId,
              'text': t.JobName,
              'Status': t.Status,
              'EndClientOrganizationName': t.EndClientOrganizationName,
              'Location': t.Location
            }
          })


          let endClientlist = this.getUnique(_this.projectDetails, "EndClientOrganizationName")
          let p = endClientlist.filter(item => item.EndClientOrganizationName != '');
          _this.listOfCients.data = __.map(p, (t, i) => {
            return { 'id': t.EndClientOrganizationName, 'text': t.EndClientOrganizationName, 'projectId': t.Id }
          })

          _this.projectStatus = true
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
$red: #cc254f;
$yellow: yellow;

$state-warning-bg: (
  "primary":$yellow
);

.container {
  height: 100%;
  box-shadow: #ddd 0px 0px 4px;
  padding: 0 15px;
}

.header {
  padding-bottom: 5px;

  p {
    color: #174474;
    font-size: 16px;
    font-weight: 600;
  }
}

.actfilter-body {
  overflow-y: auto;
  overflow-x: hidden;
}

.title {
  color: #143361;
  font-weight: 600;
  margin: 0;
  padding: 15px 0 15px;
}

.actsubtitle {
  font-weight: 600;
  padding-left: 15px;
}

.log_content {
  padding-bottom: 15px;
}

.search-bar {
  margin-left: 20px;
  margin: 15px;
  float: left;
  margin-right: 2px;
}

th {
  background-color: #ddd
}

// tr:nth-child(even):hover{
//      background-color: #aed4ff ;
//       }
// tr:nth-child(odd):hover{
//      background-color: #aed4ff;
//  }
.table {
  table-layout: fixed;
  height: calc(100vh - 210px) !important;
}

.table th,
table td {
  overflow: hidden;
}

.validation-star {
  color: #F31D1D;
}

mark {
  background-color: $yellow !important;
}


.cross-mark,
.next,
.previous {
  &:hover {
    cursor: pointer;
  }
}

.cross-mark {
  border-radius: 5px;
  padding: 5px 1px 4px 2px;
}

.previous:hover,
.next:hover,
.cross-mark:hover {
  background-color: #f6f7f8;
}

.nextImg {
  padding: 2px 16px 2px 5px;
  margin-right: -9px;
  margin-top: -5px;
}

.table_body {
  position: absolute !important;
  margin-top: 35px !important;
  overflow: auto !important;
  // height: 60vh !important;
  height: calc(100% - 35px) !important;
  display: block !important;
}

.lazy_spinner_css {
  position: relative !important;
  display: contents !important;
  margin-bottom: 10px !important;
  height: unset !important;
  bottom: 0px !important;
  top: unset !important;
}

.count_text_css {
  color: #143361;
  font-weight: 600;
}

.table_body_tr {
  display: flex !important;
  padding: 0px !important;
  position: relative !important;
}

.lazy_spinner_css div {
  position: relative !important;
  top: 0px !important;
}

.spinner_svg_css {
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
  width: 50px;
  height: 50px;
}

.spinner_circle_css {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
  stroke: #cc254f !important;
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }

  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

@keyframes color {
  0% {
    stroke: $red;
  }

  100% {
    stroke: $red;
  }
}

.spinner_text_css {
  margin: 0;
  font-weight: 700;
}

//   .header {
//   font-size: 16px;
//   font-weight: 600;
//  }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/DCAAReports.vue